import React, { useState } from "react";
import PropTypes from "prop-types";
import FormControl from "react-bootstrap/FormControl";
import { Overlay } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";

const rulesetNameRegex = new RegExp("^[a-zA-Z0-9_]+$");

export const checkRuleSetNameErrors = rulesetName => {
  const rules = [
    {
      ruleMatched: rulesetName === "",
      msg: "Ruleset name cannot be empty!"
    },
    {
      ruleMatched: rulesetName.length < 3 || rulesetName.length > 48,
      msg: "Ruleset must be between 3 and 48 characters. Please, type a different name..."
    },
    {
      ruleMatched: !rulesetNameRegex.test(rulesetName),
      msg: "Ruleset contains illegal character(s). Please, type a different name..."
    }
  ];
  return rules.find(rule => rule.ruleMatched)?.msg;
};

const YaraRulesetNameInput = React.forwardRef((props, inputRef) => {
  const { rulesetName, onChange, disabled } = props;
  const [errMsg, setErrMsg] = useState(null);
  return (
    <div className="width-100-pc" style={{ marginTop: "3px" }}>
      <span>Ruleset Name:</span>
      <FormControl
        disabled={disabled}
        id="ruleset-name-id"
        data-testid="yara_ruleset_name_input"
        className="yara-editor-ruleset"
        style={{ width: "60%", marginTop: "3px" }}
        size="sm"
        type="text"
        placeholder="Enter ruleset name"
        value={rulesetName}
        isInvalid={!!errMsg}
        onChange={e => {
          const err = checkRuleSetNameErrors(e.target.value);
          onChange(e.target.value, !!err);
          setErrMsg(err);
        }}
        ref={inputRef}
      />
      <Overlay
        target={inputRef.current}
        key={errMsg}
        show={!!errMsg}
        placement="right"
      >
        {propz => (
          <Tooltip
            id="yara-ruleset-err"
            className={"ruleset-err-tooltip"}
            {...propz}
          >
            {errMsg}
          </Tooltip>
        )}
      </Overlay>
    </div>
  );
});

YaraRulesetNameInput.propTypes = {
  rulesetName: PropTypes.string,
  errMsg: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
export default YaraRulesetNameInput;
